import styled from 'styled-components';

export const NoResult = styled.h2`
  font-size: 24px;
  font-weight: normal;
  line-height: 1.42;
`;
